import React, {useEffect, useMemo} from 'react';
import {Text} from '@gravity-ui/uikit';
import styles from './BenefactorOrders.module.scss';
import {useBenefactorOrders} from '../../hooks';
import {BenefactorOrdersTable} from '../BenefactorOrdersTable';
import {useErrorHandler, ErrorModal} from '../../../../shared';

interface BenefactorOrdersWidgetProps {
  benefactorId?: string;
}

export const BenefactorOrders = ({benefactorId}: BenefactorOrdersWidgetProps) => {
  const {handleError, isErrorModalOpen, errorInfo, handleClose} = useErrorHandler({
    resourceName: 'Заказы',
    title: 'Ошибка при получении заказов',
  });

  const {getInfiniteBenefactorOrders} = useBenefactorOrders(benefactorId || '');

  const {
    data: infiniteOrdersData,
    error: infiniteOrdersError,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isOrdersLoading,
  } = getInfiniteBenefactorOrders;

  useEffect(() => {
    if (infiniteOrdersError) {
      handleError(infiniteOrdersError as unknown as ApiError);
    }
  }, [infiniteOrdersError, handleError]);

  const orders = useMemo(() => infiniteOrdersData?.pages.flatMap((page) => page.items) || [], [infiniteOrdersData]);

  if (!benefactorId) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <Text variant="body-1">Не указан ID пользователя</Text>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <BenefactorOrdersTable
          orders={orders}
          isLoading={isOrdersLoading}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          benefactorId={benefactorId}
        />
      </div>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </div>
  );
};
